<template>
    <div>
        <section class="site-section" id="section-publications">
            <div class="container pt-5">
                <div class="col-md-12 pb-2">
                    <div class="section-heading text-center">
                        <h2 class="strong">Research Papers - Publications</h2>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="container text-white">
                                    <h4 class="text-center pt-3" style="color: #FFB20A !important; font-weight: 400"><b>Siamese Network-Based System for Criminal Identification</b></h4><h5 class="text-center">Paper publication in Springer Journal</h5>
                                    <br><br>
                                    <center><a href="https://link.springer.com/chapter/10.1007/978-981-19-2600-6_39" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="container text-white">
                                    <h4 class="text-center pt-3" style="color: #FFB20A !important; font-weight: 400"><b>PalliCare: A disruptive and a novel solution for Palliative Care</b></h4><h5 class="text-center">Paper publication in IEEE Explore</h5>
                                    
                                    <br><br>
                                    <center><a href="https://ieeexplore.ieee.org/document/9688215" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                    <br>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="container text-white">
                                    <h4 class="text-center pt-3" style="color: #FFB20A !important; font-weight: 400"><b>Emotion Detection using Social Media Data</b></h4><h5 class="text-center">Paper publication in International Journal for Research in Applied Science & Engineering Technology (IJRASET)</h5>
                                    <br><br>
                                    <center><a href="https://www.ijraset.com/best-journal/emotion-detection-using-social-media-data" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="container pt-5">
                <div class="col-md-12 pb-2">
                    <div class="section-heading text-center">
                        <h2 class="strong">Project / Article - Publications</h2>
                    </div>
                </div>
                <div class="row justify-content-center pt-2">
                    <div class="col-md-6 col-lg-12 mb-4">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="row py-4">
                                    <div class="col-md-5">
                                        <center><img :src="require('../assets/images/p1.jpg')" alt="Image placeholder" class="img-fluid"></center>
                                    </div>
                                    <div class="col-md-7 text-white">
                                        <div class="container">
                                            <h4 class="text-center" style="color: #FFB20A !important; font-weight: 400"><b>All About Covid-19</b> project publication in <br> <a href="http://www.csi-india.org/" target="_blank" style="color: #FFB20A; border-bottom: 1px solid #FFB20A"> Computer Society of India</a></h4>
                                            <br><br>
                                            <p class="mb-4 proj-desc">With COVID-19 surging to its highest peak, it's crucial to keep a check on an infodemic surging in our lives too. Keeping that in mind, I took this opportunity to create a platform with authentic real-time information revolving around COVID-19. I have created this website “AllAboutCovid-19” which gives us an insight into all the factors about COVID-19. All this data has been taken from the government sources and useful leads from sources such as - WHO, John Hopkins, Mohfw, and other local sources.
                                            </p>
                                            <!-- <p class="mb-4 proj-desc">All this data has been taken from the verified sources such as - WHO, John Hopkins, Mohfw,
                                                and other local sources. We have also provided information about the states In a very orderly
                                                fashion. We felt a need that people should get to know about different zones such as red,
                                                orange, and green. This will help people understand which places are accessible. As we all
                                                know this Lockdown can be mentally brutal too, we have added some blogs about how to keep
                                                your mental health intact and also how to keep yourself busy so you prevent overthinking and
                                                loneliness.
                                            </p> -->
                                            <br><br>
                                            <center><a href="https://www.linkedin.com/posts/computer-society-of-india-mumbai-chapter_djcsis-protocol-volume-13-activity-6705348545416974337-Jnng" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="container text-white">
                                    <h4 class="text-center pt-3" style="color: #FFB20A !important; font-weight: 400"><b>I/O Scheduling in Operating System</b> article publication in <br> <a href="https://www.geeksforgeeks.org/" target="_blank" style="color: #FFB20A; border-bottom: 1px solid #FFB20A"> GeeksforGeeks</a></h4>
                                    <br><br>
                                    <p class="mb-4 proj-desc">Operating System has a certain portion of code that is dedicated to managing Input/Output in order to improve the reliability and the performance of the system. A computer system contains CPUs and more than one device controllers connected to a common bus channel, generally referred to as the device driver. These device drivers provide an interface to I/O devices for communicating with the system hardware promoting ease of communication providing access to shared memory.
                                    </p>
                                    <br><br>
                                    <center><a href="https://www.geeksforgeeks.org/i-o-scheduling-in-operating-systems/" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="blog-entry">
                            <div class="blog-entry-text pt-0 p-2 pb-0">
                                <div class="container text-white">
                                    <h4 class="text-center pt-3" style="color: #FFB20A !important; font-weight: 400"><b>Introduction to Vue.js Instance</b> article publication in <br> <a href="https://www.geeksforgeeks.org/" target="_blank" style="color: #FFB20A; border-bottom: 1px solid #FFB20A"> GeeksforGeeks</a></h4>
                                    <br><br>
                                    <p class="mb-4 proj-desc">Vue.js is a frontend JavaScript framework developed by open source developers. It is generally used for building single-page applications. VueJS instance is specifically a View-Model according to the definition in MVVM pattern.
                                    </p>
                                    <br><br>
                                    <center><a href="https://www.geeksforgeeks.org/introduction-to-vue-js-instance/" target="_blank"><v-btn :color="yellow">View Publication</v-btn></a></center>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
            yellow: '#FFB20A'
        })
}
</script>

<style scoped>

</style>